import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as nameProfilesService from "../services/nameProfilesService";

export function useProfileQuery({ userId, childNameId }) {
  return useQuery({
    queryKey: ["profile", userId, childNameId ?? null],
    queryFn: () => nameProfilesService.getProfile({ userId, childNameId }),
    enabled: !!userId,
  });
}

export function useGroupProfilesQuery(groupId) {
  return useQuery({
    queryKey: ["groupProfiles", groupId],
    queryFn: () => nameProfilesService.getGroupProfiles(groupId),
    enabled: !!groupId,
  });
}

export function useUpsertProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: nameProfilesService.upsertProfile,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["profile", variables.userId, variables.childNameId ?? null],
      });
      // Prefix match — refresh every group's quick-view cache, not just one group id.
      queryClient.invalidateQueries({ queryKey: ["groupProfiles"] });
    },
  });
}
